<template>
  <JitsiMeeting v-if="this.waitingRoom"
                :roomName="this.waitingRoom.wr_code"
                :domain="this.waitingRoom.wr_domain"
                :jwt="this.waitingRoom.wr_jwt"
                :configOverwrite="{
            subject: 'Teleconsulta',
            hideConferenceSubject: false,
            disableProfile: true,
            startWithVideoMuted: false,
            hideConferenceTimer: true,
            defaultLocalDisplayName: 'Você',
            prejoinPageEnabled: false,
            toolbarButtons: [
                'microphone', 'camera', 'desktop', 'fullscreen',
                'hangup', 'toggle-camera',
                'etherpad', 'raisehand',
                'select-background', 'tileview', 'chat',
            ],
        }"
                :interfaceConfigOverwrite="{
            APP_NAME: 'Ubbimed',
            MOBILE_APP_PROMO: false,
            SHOW_JITSI_WATERMARK: false,
            DEFAULT_BACKGROUND: '#780f5a',
            HIDE_INVITE_MORE_HEADER: true,
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
            SETTINGS_SECTIONS: ['devices'],
            LANG_DETECTION: false,
        }"
                lang="ptBR"
                width="100%"
                :height=this.height
                :userInfo="{
            displayName: this.displayName,
            email: this.userAuth?.user_email ?? '',
        }"
                @onApiReady="(externalApi) => handleApiReady(externalApi)"
                @onReadyToClose="handleReadyToClose"
                @getIframeRefOnApiReady="handleJitsiIFrameRef1"
  />

  <div v-else class="attendance-empty">
    <p>{{ loading ? 'Entrando na sala do atendimento...' : 'A sala do atendimento não está disponível.' }}</p>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Swal from "sweetalert2";
import {JitsiMeeting} from "@jitsi/vue-sdk";

export default {
  name: "PatientScheduleAttendance",
  components: {
    JitsiMeeting
  },
  data() {
    return {
      schedule: null,
      queue: null,
      waitingRoom: null,
      scheduleId: null,
      schedToken: null,
      userToken: null,
      height: null,
      loading: true,
      jistiReference: null,
    }
  },
  computed: {
    userAuth() {
      return this.$store.state.auth.user;
    },
    displayName() {
      return this.userAuth?.user_name ?? this.schedule?.patient_name ?? 'Paciente';
    },
  },
  created() {
    this.scheduleId = this.$route.params.scheduleId;
    this.schedToken = this.$route.query.sched_token;
    this.userToken = this.$route.query.user_token;
  },
  mounted() {
    this.height = window.innerHeight
    this.leaveRoom = this.leaveRoom.bind(this);
    window.addEventListener('pagehide', this.leaveRoom);
    this.findSchedule().then(() => this.wsConnect());
  },
  beforeUnmount() {
    window.removeEventListener('pagehide', this.leaveRoom);
    this.leaveRoom();

    if (this.queue)
      Echo.leave(`attendances.${this.queue.id_queue}`);
  },
  methods: {
    findSchedule() {
      let schedUrl = `/users/${this.userAuth?.id_user}/schedules/${this.scheduleId}`;
      if (this.schedToken && this.userToken) {
        schedUrl = `/schedule/attendance-token?token=${this.schedToken}&user_token=${this.userToken}`;
      }

      return http.get(schedUrl).then(async (response) => {
        this.schedule = response.data;
        if (this.schedule.sched_online_call_finished) {
          this.$router.push('/schedules');
          return;
        }

        this.queue = this.schedule.queue;
        this.waitingRoom = this.queue?.waiting_room;
        this.loading = false;

        return response;
      }).catch((e) => {
        this.loading = false;
        let title = 'Falha ao carregar o agendamento.';
        if (e.response.status === 422) {
          title = e.response.data;
        }

        Swal.fire({
          text: title,
          title: 'Opsss',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK, Acessar a Ubbimed',
          customClass: {
            confirmButton: "btn btn-primary",
          }
        }).then(() => {
          this.$router.push('/schedules');
        });
      });
    },
    wsConnect() {
      if (!this.queue) return;

      Echo.private(`attendances.${this.queue.id_queue}`)
        .listen('ScheduleStarted', () => {
          // Já está na sala: recarregar deixaria a sessão anterior pendurada e
          // o paciente apareceria duas vezes para o profissional.
          if (this.waitingRoom) return;

          window.location.reload();
        })
        .listen('ScheduleCanceled', () => this.$router.push('/schedules'))
        .listen('ScheduleFinished', () => this.$router.push('/schedules'));
    },
    leaveRoom() {
      const reference = this.jistiReference;
      if (!reference) return;

      this.jistiReference = null;

      try {
        reference.executeCommand('hangup');
      } catch (e) {
        // a chamada já tinha sido encerrada
      }

      try {
        reference.dispose();
      } catch (e) {
        // nada a liberar
      }
    },
    handleApiReady(jistiReference) {
      this.jistiReference = jistiReference;
      this.jistiReference.addListener('incomingMessage', (data) => {
        if (!this.userAuth?.id_user) return;

        let url = `/users/${this.userAuth.id_user}/schedules/${this.scheduleId}/chat-messages`;
        let payload = {
          name: data.nick,
          message: data.message,
          id_prof: this.schedule.id_prof,
        };

        http.post(url, payload);
      });
    },
    handleReadyToClose() {
      // chamar a api
      this.$router.push('/schedules');
    },
    handleJitsiIFrameRef1(iframeRef) {
      // customizar o iframe do jitsi
    },
  }
}
</script>

<style scoped>
#jitsiConferenceFrame0 {
  overflow: hidden;
}

.attendance-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
  color: #6c757d;
}
</style>